import React from 'react'
import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { TransactionActivity } from '@plug-core/interfaces/transactionActivity'
import useTransactionOtherParty from '@plug-core/hooks/useTransactionOtherParty'
import useToast from '@hooks/useToast'

export const TransactionOtherParty = ({
  transaction,
  long,
  copy,
}: {
  transaction: TransactionActivity
  long?: boolean
  copy?: boolean
}) => {
  const { t } = useTranslation()
  const { setToastMessage } = useToast()
  const { otherParty, isRecognized, fullAddress } = useTransactionOtherParty({
    transaction,
    long,
  })

  const onCopy = () => {
    if (!copy) return

    setToastMessage(t('deposit.addressCopied'))
    navigator.clipboard.writeText(fullAddress)
  }

  return (
    <Typography
      color={isRecognized ? 'rainbow.blue' : undefined}
      component="span"
      fontSize="inherit"
      onClick={onCopy}
      sx={{ cursor: copy ? 'pointer' : undefined }}
    >
      {otherParty}
    </Typography>
  )
}
